'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { Clock01Icon, FireIcon, Rocket01Icon } from '@/components/ui/icon/glyphs';
import { InfoModal } from '@/components/ui/info-modal';
interface StreaksHowItWorksDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}
export function StreaksHowItWorksDialog(t0) {
  const $ = _c(48);
  const {
    open,
    onOpenChange
  } = t0;
  const t = useTranslations("streaks.how_it_works");
  let t1;
  if ($[0] !== t) {
    t1 = t("title");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t) {
    t2 = t("intro");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t) {
    t3 = t("got_it");
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== onOpenChange) {
    t4 = () => onOpenChange(false);
    $[6] = onOpenChange;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = <InfoModal.Footer cta={t3} onClose={t4} />;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t) {
    t6 = t("step1_title");
    $[11] = t;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t) {
    t7 = t("step1_desc");
    $[13] = t;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t6 || $[16] !== t7) {
    t8 = <InfoModal.IconItem icon={FireIcon} title={t6} description={t7} />;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t) {
    t9 = t("step2_title");
    $[18] = t;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t) {
    t10 = t("step2_desc");
    $[20] = t;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10 || $[23] !== t9) {
    t11 = <InfoModal.IconItem icon={Rocket01Icon} title={t9} description={t10} />;
    $[22] = t10;
    $[23] = t9;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== t) {
    t12 = t("step3_title");
    $[25] = t;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== t) {
    t13 = t("step3_desc");
    $[27] = t;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== t12 || $[30] !== t13) {
    t14 = <InfoModal.IconItem icon={Clock01Icon} title={t12} description={t13} />;
    $[29] = t12;
    $[30] = t13;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== t11 || $[33] !== t14 || $[34] !== t8) {
    t15 = <InfoModal.IconList>{t8}{t11}{t14}</InfoModal.IconList>;
    $[32] = t11;
    $[33] = t14;
    $[34] = t8;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  let t16;
  if ($[36] !== t) {
    t16 = t("callout");
    $[36] = t;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  let t17;
  if ($[38] !== t16) {
    t17 = <InfoModal.Callout>{t16}</InfoModal.Callout>;
    $[38] = t16;
    $[39] = t17;
  } else {
    t17 = $[39];
  }
  let t18;
  if ($[40] !== onOpenChange || $[41] !== open || $[42] !== t1 || $[43] !== t15 || $[44] !== t17 || $[45] !== t2 || $[46] !== t5) {
    t18 = <InfoModal open={open} onOpenChange={onOpenChange} title={t1} description={t2} footer={t5}>{t15}{t17}</InfoModal>;
    $[40] = onOpenChange;
    $[41] = open;
    $[42] = t1;
    $[43] = t15;
    $[44] = t17;
    $[45] = t2;
    $[46] = t5;
    $[47] = t18;
  } else {
    t18 = $[47];
  }
  return t18;
}